import React, { useEffect, useState } from "react";
import SUG from "./shared/suggestions";

export default function KeySkillsSection({ value = [], onChange }) {
  const [skills, setSkills] = useState(value || []);
  const [open, setOpen] = useState(false);
  const [tempSkills, setTempSkills] = useState([]);
  const [input, setInput] = useState("");

  useEffect(() => setSkills(value || []), [value]);

  const handleAddSkill = (skill) => {
    const trimmed = (skill || input).trim();
    if (trimmed && !tempSkills.includes(trimmed)) {
      setTempSkills([...tempSkills, trimmed]);
      setInput("");
    }
  };

  const handleRemoveTemp = (idx) => {
    const next = tempSkills.filter((_, i) => i !== idx);
    setTempSkills(next);
  };

  const handleSave = () => {
    const next = [...skills, ...tempSkills];
    setSkills(next);
    onChange(next);
    setTempSkills([]);
    setOpen(false);
  };

  const remove = (i) => {
    const next = skills.filter((_, idx) => idx !== i);
    setSkills(next);
    onChange(next);
  };

  // Full suggestion match (no trimming)
  const suggestions = SUG.skills.filter(
    (s) =>
      input &&
      s.toLowerCase().includes(input.toLowerCase()) &&
      !tempSkills.includes(s)
  );

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Key skills</h3>
        <div className="card-actions">
          <button className="link" onClick={() => setOpen(true)}>Add</button>
        </div>
      </div>

      <div className="card-body">
        {skills.length === 0 ? (
          <p className="muted">No skills added</p>
        ) : (
          <div className="chips">
            {skills.map((s, i) => (
              <span key={i} className="chip">
                {s}
                <button className="x" onClick={() => remove(i)}>×</button>
              </span>
            ))}
          </div>
        )}
      </div>

      {open && (
        <div className="modal-backdrop">
          <div className="modall-large">
            <div className="modal-head">
              <h3>Add Multiple Skills</h3>
              <button className="x" onClick={() => setOpen(false)}  > ✕ </button>
            </div>

            <div className="modal-body">
              <div className="form-group autosuggest-wrapper">
                <label>Type a skill</label>
                <input
                  type="text"
                  value={input}
                  placeholder="Type to search and press Enter"
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleAddSkill())}
                />
                {suggestions.length > 0 && (
                  <ul className="suggestions-list">
                    {suggestions.map((s, idx) => (
                      <li
                        key={idx}
                        onClick={() => handleAddSkill(s)} // ✅ Adds full skill, not partial
                      >
                        {s}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {tempSkills.length > 0 && (
                <div className="chips" style={{ marginTop: "10px" }}>
                  {tempSkills.map((s, i) => (
                    <span key={i} className="chip">
                      {s}
                      <button className="x" onClick={() => handleRemoveTemp(i)}>×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="modall-actions">
              <button className="btn secondary" onClick={() => setOpen(false)}>Cancel</button>
              <button className="btn" onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
